import { SvgIcon } from "@/components/icon"
import Typography from "@/components/typography/Typography"
import { useBreakpoint } from "@/hooks/useBreakpoint"
import { FC } from "react"
import adminImg from "../assets/hex-icons/admin-alt.png"
import crossCircleImg from "../assets/hex-icons/cross-circle.png"
import envelopeImg from "../assets/hex-icons/envelope.png"
import memoCircleImg from "../assets/hex-icons/memo-circle-check.png"
import octagonImg from "../assets/hex-icons/octagon-check.png"
import "./HexListItem.less"

const { Paragraph } = Typography
export type IconType = keyof typeof ICONS_MAP

export const ICONS_MAP = {
  admin: adminImg,
  crossCircle: crossCircleImg,
  envelope: envelopeImg,
  memoCircle: memoCircleImg,
  octagon: octagonImg,
} as const

type Props = {
  icon: IconType
  text: string
}

const HexListItem: FC<Props> = ({ text, icon }) => {
  const { xxl, xl, lg, md, sm } = useBreakpoint()

  return (
    <div className={"hex-list-group"}>
      <div className={"hex-list-item-wrapper"}>
        <div className={"hex-wrapper"}>
          <div className={"hex-img-wrapper"}>
            <img src={icon} alt={""} />
          </div>
        </div>
        <div className={"orange-circle-wrapper"}>
          <SvgIcon type={"little-cross"} />
        </div>
      </div>

      <Paragraph
        color={"website-secondary"}
        size={!xl ? "sm" : "lg"}
        style={{ marginLeft: !(xxl || xl || lg || md || sm) ? 8 : 16 }}
      >
        {text}
      </Paragraph>
    </div>
  )
}

export default HexListItem
